.sn-disclaimer {
    padding-top: var(--spacing-3xl);

    @include desktop {
        padding-top: var(--spacing-6xl);
    }
    
    &__container {
        @include container;
    }

    &__box {
        display: flex;
        align-items: center;
        gap: var(--spacing-md);
        padding: var(--spacing-md) var(--spacing-lg);
        border: 1px dashed $border-color-brand-primary;
        border-radius: $radius-size-md;
    }

    &__icon {
        flex-shrink: 0;
        display: block;
    }

    // `&__text` is the fallback paragraph the component renders itself; `.me-text`
    // covers the same paragraph when it arrives through the `text` slot.
    &__text,
    &__box .me-text {
        margin: 0;
        font-size: map-get($font-sizes, md);
        line-height: map-get($line-heights, lg);
        color: $text-color-primary;
    }

    &__link {
        color: $text-color-brand-primary;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}
